import { AccredibleIconComponentModule } from '@accredible-frontend-v2/new-components/icon';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AccredibleLinkComponent } from './link.component';

@NgModule({
  imports: [CommonModule, RouterModule, AccredibleIconComponentModule],
  exports: [AccredibleLinkComponent],
  declarations: [AccredibleLinkComponent],
  providers: [],
})
export class AccredibleLinkComponentModule {}
